import { PickerPlan, PickerPremium } from '../../../lib/plans';
import { activePremiumSubscription } from './settings-plan';

// Is the account's active plan the top ("max"/Max+) catalog tier? This is the ONE web
// definition of that decision — the plan card's CTA reads "Change" instead of "Upgrade"
// on it (Monday 12757143948), and it gates the top-up button. Shared by the account cards
// (via useSettingsPlanView) AND the always-mounted drawer credits card (useCreditsSummary),
// so the two surfaces can never disagree about which plan is Max+.
//
// The native apps make the same decision by matching the credits-overview plan id against a
// fixed Max+ GUID (`SettingsPlan.isMaxPlusPlan`); web keys on the catalog `key === 'max'`
// instead because that is the signal the settings surfaces already carry (and the same
// catalog option drives the top-up pack). Both identify the same plan.
//
// Pure so it is unit-tested (`test/max-plus.test.ts`) without the app graph — keep it that
// way; do not add a runtime import here.
export function activePlanIsMaxPlus(premium: PickerPremium | null, plans: PickerPlan[] | null): boolean {
  const sub = activePremiumSubscription(premium);
  const currentOption = (plans ?? [])
    .flatMap((p) => p.options.map((option) => ({ key: p.key, agentPlanId: option.agentPlanId })))
    .find((x) => x.agentPlanId === sub?.planId);
  return currentOption?.key === 'max';
}
